import { useEffect, useState } from 'react'
import type { Services } from '@/services/services'
import type { MapRow } from '@/components/Map/HitMap'

export function useHitMap(services: Services, url: string) {
  const [state, setState] = useState<{ url: string, rows?: MapRow[], error?: string }>({ url })
  useEffect(() => {
    const controller = new AbortController()
    setState({ url })
    services.session.fetchWithToken(url, { signal: controller.signal }).then(async response => {
      if (!response.ok) {
        const body = await response.json().catch(() => ({}))
        throw new Error(response.status === 422 && body.code === 'HIT_MAP_TOO_MUCH_DATA'
          ? 'map.too_much_data' : 'map.load_error')
      }
      const rows: MapRow[] = await response.json()
      if (!controller.signal.aborted) setState({ url, rows })
    }).catch(error => {
      if (!controller.signal.aborted) setState({ url, rows: [], error: error.message === 'map.too_much_data' ? error.message : 'map.load_error' })
    })
    return () => controller.abort()
  }, [services, url])
  // Hide old points immediately, including the render preceding effect cleanup.
  return state.url === url ? state : { url, rows: undefined, error: undefined }
}
